import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route,Navigate } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About'; 
import Actions from './pages/Actions'; 
import PublicInput from './pages/PublicInput';
import Resources from './pages/Resources';
import AdoptedPlans from './pages/AdoptedPlans';
import Footer from './components/Footer';
import Header from './components/Header';
import TransportationPlan from './pages/TransportationPlan';
import GreenwaysPlan from './pages/GreenwaysPlan';
import CompleteStreetsPlan from './pages/CompleteStreetsPlan';
import News from './pages/News';
import PublicEngagementDetail from './pages/PublicEngagementDetail';
import PublicEngagementEventDetail from './pages/PublicEngagementEventDetail';
import LanguageSwitcher from './components/LanguageSwitcher';
import MiamiLakesVzFarmersMarketKickoffEvent from './pages/news/MiamiLakesVzFarmersMarketKickoffEvent';
import MiamiLakesVzCoffeeEventFireStation from './pages/news/MiamiLakesVzCoffeeEventFireStation';
import VZTakesMiamiLakesByStorm from './pages/news/VZTakesMiamiLakesByStorm';
import ChamberOfCommerceMonthlyLuncheon from './pages/news/ChamberOfCommerceMonthlyLuncheon';
import SeniorBingoLuncheon from './pages/news/SeniorBingoLuncheon';
import LetsTakeTheBus from './pages/news/LetsTakeTheBus';
import CarForHeroesPressRelease from './pages/news/CarForHeroesPressRelease';



import i18n from 'i18next';

const App = () => {
  const [currentLang, setCurrentLang] = useState(i18n.language || 'en');

  const toggleLanguage = () => {
    const newLang = currentLang === 'en' ? 'es' : 'en';
    i18n.changeLanguage(newLang);
    setCurrentLang(newLang);
  };

useEffect(() => {
  // Update on language change events
  const onLanguageChanged = (lng) => setCurrentLang(lng);
  i18n.on('languageChanged', onLanguageChanged);

  // Update immediately when i18n is initialized
  const onInitialized = (options) => setCurrentLang(i18n.language);
  i18n.on('initialized', onInitialized);

  // In case i18n is already initialized, update immediately
  if (i18n.isInitialized) setCurrentLang(i18n.language);

  return () => {
    i18n.off('languageChanged', onLanguageChanged);
    i18n.off('initialized', onInitialized);
  };
}, []);


  return (
    <Router basename="/vz">
       <Header toggleLanguage={toggleLanguage} currentLang={currentLang}/>
      <Routes>
           <Route path="/" element={<Navigate to="/miami-lakes-home" replace />} />


        <Route
          path="/miami-lakes-home"
          element={<Home toggleLanguage={toggleLanguage} currentLang={currentLang} />}
        />
        <Route
          path="/miami-lakes-about"
          element={<About toggleLanguage={toggleLanguage} currentLang={currentLang} />}
        />
        <Route
          path="/miami-lakes-transportation-master-plan"
          element={<TransportationPlan toggleLanguage={toggleLanguage} currentLang={currentLang} />}
        />
        <Route
          path="/miami-lakes-greenways-trails-master-plan"
          element={<GreenwaysPlan toggleLanguage={toggleLanguage} currentLang={currentLang} />}
        />
        <Route
          path="/miami-lakes-complete-streets-master-plan"
          element={<CompleteStreetsPlan toggleLanguage={toggleLanguage} currentLang={currentLang} />}
        />
        <Route
          path="/miami-lakes-actions"
          element={<Actions toggleLanguage={toggleLanguage} currentLang={currentLang} />}
        />
        <Route
          path="/miami-lakes-public-input"
          element={<PublicInput toggleLanguage={toggleLanguage} currentLang={currentLang} />}
        />      
              <Route
          path="/miami-lakes-resources"
          element={<Resources toggleLanguage={toggleLanguage} currentLang={currentLang} />}
        />
              <Route
          path="/miami-lakes-adopted-plans"
          element={<AdoptedPlans toggleLanguage={toggleLanguage} currentLang={currentLang} />}
        />
                      <Route
          path="/miami-lakes-news"
          element={<News toggleLanguage={toggleLanguage} currentLang={currentLang} />}
        />

          <Route path="/news" element={<News />} />
          <Route path="/public-engagement/:slug" element={<PublicEngagementDetail />} />
          <Route path="/public-engagement/:slug/:eventSlug" element={<PublicEngagementEventDetail />} />
  <Route
    path="/news/miami-lakes-vz-farmers-market-kickoff-event"
    element={<MiamiLakesVzFarmersMarketKickoffEvent />}
  />
    

  <Route
    path="/news/miami-lakes-vz-coffee-event-fire-station"
    element={<MiamiLakesVzCoffeeEventFireStation />}
  />

    <Route
    path="/news/vz-takes-miami-lakes-by-storm"
    element={<VZTakesMiamiLakesByStorm />}
  />

      <Route
    path="/news/chamber-of-commerce-monthly-luncheon"
    element={<ChamberOfCommerceMonthlyLuncheon />}
  />

        <Route
    path="/news/senior-bingo-luncheon"
    element={<SeniorBingoLuncheon />}
  />

          <Route
    path="/news/lets-take-the-bus"
    element={<LetsTakeTheBus />}
  />

            <Route
    path="/news/car-for-heroes-press-release"
    element={<CarForHeroesPressRelease />}
  />
      </Routes>

      {/* Footer is outside Routes, so it appears on all pages */}
      <Footer toggleLanguage={toggleLanguage} currentLang={currentLang} />
      <LanguageSwitcher toggleLanguage={toggleLanguage} currentLang={currentLang} />
    </Router>
  );
};

export default App;
